import React, { FC } from 'react';
import { Row, useScreenClass } from 'react-grid-system';
import { SectionTitle } from '../shared';
import styled from 'styled-components';
import FULLSCOPE from '../../assets/FullScope.png';
import HINDENBURG from '../../assets/Hindenburg.png';
import AIR_LOGO from '../../assets/AIR_Logo.png';
import SAMSON from '../../assets/Samson.png';
import WLIW from '../../assets/wliwFM.png';
import PODFEST from '../../assets/PODFEST.png';
import LIBSYN from '../../assets/libsynlogo.png';
import ONAIR from '../../assets/On_Air_Logo.png';

const Image = styled.img<{ isDesktop: boolean }>`
  /* On desktop, use a fixed width; on mobile, use a percentage of the container */
  width: ${(props) => (props.isDesktop ? '225px' : '80%')};
  height: auto; /* Maintain aspect ratio */
  /* Use different margins depending on screen size */
  margin: ${(props) => (props.isDesktop ? '0 3rem' : '1rem auto')};
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer; /* Indicate interactivity */

  &:hover {
    transform: scale(1.1); /* Slightly enlarge the image on hover */
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3); /* Add a subtle shadow */
  }
`;

const Section = styled.section<{ isDesktop: boolean }>`
  margin-top: 6rem;
  height: auto;
  padding: ${(props) => (props.isDesktop ? '1rem 0 5rem 0' : '2rem 0')};

  /* Optionally adjust anchor styling on mobile if needed */
  a {
    width: ${(props) => (props.isDesktop ? 'auto' : '60%')};
    margin: ${(props) => (props.isDesktop ? '0' : '0.5rem 0')};
  }
`;

const PerksPanel = styled.div`
  max-width: 960px;
  margin: 1rem auto 3rem;
  padding: 1.25rem 2rem;
  background: #6B000D;
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  color: #fff;
  text-align: left;

  .panel-title {
    font-size: 1.1rem;
    line-height: 1.7;
    margin: 0 0 1rem 0;
    text-align: center;
    font-weight: 600;
    color: #fff;
  }

  .perks {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
    column-gap: 4rem; /* adjust spacing between the two columns */
    row-gap: 0.75rem;
    list-style: none;
    padding: 0;
    margin: 0.5rem auto 0 auto;
    max-width: 800px; /* keeps content centered */
    text-align: left;
  }

  .perks li {
    line-height: 1.6;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
  }

  .perks li::before {
    content: '✓';
    position: static;
    margin-right: 0.25rem;
    line-height: 1.2;
    font-weight: 700;
    color: #fff;
  }

  @media (max-width: 768px) {
    padding: 1rem 2rem;
    .perks { grid-template-columns: 1fr; }
    .panel-title { text-align: left; }
  }

  @media (max-width: 480px) {
    max-width: 90%;
    margin: 0 auto 2rem;
  }
`

const Affiliates: FC = () => {
  const screenClass = useScreenClass();
  const isDesktop = ['md', 'lg', 'xl'].includes(screenClass);

  return (
    <Section isDesktop={isDesktop}>
      <SectionTitle color="black">
        Enjoy Perks from Our Sponsors
      </SectionTitle>
      <PerksPanel>
        <ul className="perks">
          <li>Job opportunities</li>
          <li>Access to Stony Brook recording studios</li>
          <li>One-on-one technical instruction</li>
          <li>Sponsor-provided tools</li>
          <li>Invitations to industry events</li>
          <li>Publishing opportunities</li>
          <li>Career support via our active alumni network</li>
          <li>.edu discounts across key tools and platforms</li>
        </ul>
      </PerksPanel>
      <Row align="center" justify="center" style={{ margin: '4rem auto' }}>
        <a href="https://libsyn.com/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={LIBSYN} alt="Libsyn Logo" />
        </a>
        <a href="http://www.samsontech.com/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={SAMSON} alt="Samson Logo" />
        </a>
        <a href="https://www.descript.com/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={FULLSCOPE} alt="FullScope Logo" />
        </a>
      </Row>
      <Row align="center" justify="center" style={{ margin: '1rem auto' }}>
        <a href="https://www.onairfest.com/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={ONAIR} alt="On Air Fest Logo" />
        </a>
        <a href="https://www.wliw.org/radio/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={WLIW} alt="WLIWFM Logo" />
        </a>
        <a href="https://hindenburg.com/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={HINDENBURG} alt="Hindenburg Logo" />
        </a>
      </Row>
      <Row
        align="center"
        justify="center"
        style={{ margin: '2rem auto', textAlign: 'center' }}
      >
        <a href="https://podfestexpo.com" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={PODFEST} alt="Podfest Logo" />
        </a>
        <a href="https://airmedia.org/" target="_blank" rel="noopener noreferrer">
          <Image isDesktop={isDesktop} src={AIR_LOGO} alt="AIR Logo" />
        </a>
      </Row>
    </Section>
  );
};

export default Affiliates;
